<app-loader-bar></app-loader-bar>
<main>
  <div class="flex-grow-1">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</main>
